<div class="card">
  <div class="card-header card-chart card-header-primary">
    <h2 class="card-title text-center">
      <b>{{ titulo }} alcance</b>
    </h2>
  </div>
  <div class="card-body">
    <div class="container">
      <div mat-dialog-content>
        <form [formGroup]="datosform">
          <div class="row">
            <div class="col-md-4">
              <mat-form-field>
                <mat-label>Fecha Inicio: </mat-label>
                <input
                  matInput
                  formControlName="dateStartCtrl"
                  [matDatepicker]="dateStart"
                  placeholder="Fecha Inicio: "
                  [(ngModel)]="fechaInicio"
                  readonly
                  aria-label="Fecha Inicio:"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="dateStart"
                ></mat-datepicker-toggle>
                <mat-datepicker #dateStart></mat-datepicker>
              </mat-form-field>
              <mat-error
                *ngIf="
                  this.datosform.controls['dateStartCtrl'].errors?.required
                "
                >El campo es requerido.</mat-error
              >
            </div>
            <div class="col-md-3">
              <mat-form-field>
                <mat-label>Fecha Fin: </mat-label>
                <input
                  matInput
                  formControlName="dateEndCtrl"
                  [matDatepicker]="dateEnd"
                  placeholder="Fecha Fin: "
                  [(ngModel)]="fechaFin"
                  readonly
                  aria-label="Fecha Fin:"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="dateEnd"
                ></mat-datepicker-toggle>
                <mat-datepicker #dateEnd></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>Justificaci&oacute;n: </mat-label>
                <textarea
                  maxlength="500"
                  matInput
                  placeholder="Justificación: "
                  aria-label="Justificación:"
                  formControlName="descriptionProjectCtrl"
                  [(ngModel)]="objectAlcance.justificacion"
                  oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"
                ></textarea>
              </mat-form-field>
            </div>
          </div>
          n
          <div class="row">
            <div class="col-sm-3">
              <mat-form-field>
                <mat-label>Horas totales: </mat-label>
                <input
                  matInput
                  placeholder="Horas:"
                  aria-label="Horas totales:"
                  formControlName="horasTotales"
                  [(ngModel)]="objectAlcance.horasTotales"
                  soloNumero
                  maxlength="5"
                />
              </mat-form-field>
            </div>
            <div class="col-sm-3">
              <mat-form-field>
                <mat-label>Horas Etc: </mat-label>
                <input
                  matInput
                  placeholder="Etc"
                  aria-label="Horas Etc:"
                  formControlName="horasEtc"
                  [(ngModel)]="objectAlcance.horasEtc"
                  oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"
                  soloNumero
                  maxlength="5"
                />
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <mat-form-field>
                <mat-label>Presupuesto autorizado:</mat-label>
                <input
                  matInput
                  placeholder="Presupuesto autorizado"
                  aria-label="Presupuesto autorizado:"
                  soloNumero
                  maxlength="10"
                  formControlName="presupuestoAutorizado"
                  [(ngModel)]="objectAlcance.presupuestoAutorizado"
                  oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"
                />
              </mat-form-field>
            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-sm-6">
            <button
              [disabled]="datosform.invalid"
              mat-button
              (click)="save()"
              class="btn btn-success"
              *ngIf="esConsulta"
            >
              Guardar <i class="material-icons"> save </i>
            </button>
          </div>
          <div class="col-sm-6">
            <button
              mat-raised-button
              class="btn btn-info btn-sm"
              (click)="onNoClick()"
            >
              <span><i class="material-icons">cancel</i></span>
              &nbsp; Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
